const StyleCta = `
<style>
.cta-1 {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    font-weight: 400;
    font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 26px;
    letter-spacing: .28px;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
    height: 40px;
    line-height: 38px;
    border: 1px solid;
    outline: 1px solid transparent;
    background: transparent;
    padding: 4px 24px;
    border-radius: 11px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    transition: background .45s, color .45s, border .45s;
    -moz-transition: background .45s, color .45s, border .45s;
    -webkit-transition: background .45s, color .45s, border .45s;
    -ms-transition: background .45s, color .45s, border .45s;
    -o-transition: background .45s, color .45s, border .45s;
    color: #c3c7c7;
    background: #000;
    border-color: transparent;
}

.cta-1:not(.disabled):focus, .cta-1:not(.disabled):hover {
    background: #d2eae5;
    border-color: #d2eae5;
    color: #000;
    cursor: pointer;
}

@media screen and (min-width: 1025px)
.cta-1 {
    width: auto;
    height: 40px;
    line-height: 38px;
}
</style>

`;

export { StyleCta };
